import { healthSummaryRetrieve } from 'Redux/modules/webChat/actions';
import { getHealthSummaryById } from 'Selectors/webChat/healthSummary';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SummaryDetails from '../ConsultHistory/Summary/SummaryDetails';

const WrapHealthSummaryDetails = ({ consult }) => {
  const healthSummaries = consult.healthSummary ?? [];
  const healthSummaryId = healthSummaries[0]?.healthSummaryId;
  const doctorId = healthSummaries[0]?.doctorId;

  const dispatch = useDispatch();
  const getHealthSummary = useCallback(async () => {
    await dispatch(healthSummaryRetrieve({ summaryId: healthSummaryId, doctorId }));
  }, [dispatch, healthSummaryId, doctorId]);

  useEffect(() => {
    if (healthSummaryId) {
      getHealthSummary();
    }
  }, [healthSummaryId, getHealthSummary]);

  const summary = useSelector(state => getHealthSummaryById(state, healthSummaryId));

  return <SummaryDetails healthSummary={summary} />;
};
WrapHealthSummaryDetails.propTypes = {
  consult: PropTypes.shape({
    healthSummary: PropTypes.arrayOf(
      PropTypes.shape({
        healthSummaryId: PropTypes.string,
        doctorId: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default WrapHealthSummaryDetails;
